const config = {
  ENVIRONMENT_NAME: 'staging',
  forwoodId: {
    URL: 'https://id.staging.europe.forwoodsafety.com',
    USER_TOKEN_URL: 'https://0dbo1ck8q8.execute-api.eu-west-1.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'eu-west-1',
    URL: 'https://yu69w2oru0.execute-api.eu-west-1.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.staging.europe.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.staging.europe.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.staging.europe.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.europe.forwoodsafety.com',
    WEBSOCKET: 'wss://o2xqzbbzq1.execute-api.eu-west-1.amazonaws.com/staging'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
